import { Component, Object3D } from '@wonderlandengine/api';
import { property } from '@wonderlandengine/api/decorators.js';
import { TriggerTarget } from '../interactions/triggerTarget.js';
import { TextsManager } from '../core/texts-manager.js';

export class ShowDialog extends Component {
    static TypeName = 'show-dialog';
    private _triggerTarget?: TriggerTarget | null;

    @property.object({ required: true })
    dialogTarget!: Object3D;

    @property.string('')
    text = '';

    start(): void {
        this._triggerTarget = this.object.getComponent(TriggerTarget)!;
    }

    onActivate(): void {
        this._triggerTarget?.onExecute.add(this._onExecute);
    }

    onDeactivate(): void {
        this._triggerTarget?.onExecute.remove(this._onExecute);
    }

    update(dt: number) {}

    private _onExecute = () => {
        TextsManager.instance.showText(this.text, this.dialogTarget);
    };
}
